import { cx } from '@flowus/common/cx';
import type { FC } from 'react';
import { Virtuoso } from 'react-virtuoso';
import { Icon } from 'src/common/components/icon';
import { Tooltip } from 'src/common/components/tooltip';
import { clearUploadInfo } from 'src/services/upload';
import { DownloadItem } from './download-item';
import { useAllTransferTask, useTransferStatus } from './hooks';
import { TransferStatus, transferStatusIcons } from './types';
import { UploadItem } from './upload-item';

interface Props {
  onHide: () => void;
  className?: string;
}
export const TransferList: FC<Props> = (props) => {
  const status = useTransferStatus();
  const { failed, succeeded, tasks } = useAllTransferTask();

  return (
    <div className={cx('next-modal w-[480px]', props.className)}>
      <div className="flex items-center w-full justify-between h-[60px] px-4">
        <div className="flex items-center">
          <Icon
            className={status === TransferStatus.TRANSFERRING ? 'animate-spin' : ''}
            name={transferStatusIcons[status].name}
            style={{ color: transferStatusIcons[status].color }}
            size="large"
          />
          <span className="ml-2.5 text-h3">传输列表</span>
          {status === TransferStatus.ALL_SUCCESS && (
            <span className="ml-2.5 text-t1">全部完成</span>
          )}
          {status === TransferStatus.TRANSFERRING && (
            <span className="ml-2.5 text-t1">{`${succeeded + failed}/${tasks.length}`}</span>
          )}
          {status === TransferStatus.SOME_FAIL && (
            <span className="ml-2.5 text-t1">{`已成功${succeeded},失败${failed}`}</span>
          )}
        </div>
        <Tooltip popup="隐藏传输列表">
          <Icon
            className="cursor-pointer"
            name={'IcArrowShow'}
            size="middle"
            onClick={() => {
              props.onHide();
            }}
          />
        </Tooltip>
      </div>
      <div className="bg-grey6 w-full h-px mb-1" />
      <Virtuoso
        {...{
          overscan: 200,
          className: 'mx-2',
          totalCount: tasks.length,
          style: {
            height: window.innerHeight * 0.5 - 60, // 不知道为啥用百分比不生效
          },
          itemContent: (index: number) => {
            const task = tasks?.[index];
            if (!task) return null;
            /**
             * 每个类型的item逻辑不一样
             * 如果ui差不多，可以考虑把UploadItem抽出一个通用的受控组件(不含业务逻辑)，供其他类型的item使用
             * 如果ui差太多，还是自己再写一个item吧
             */
            switch (task.taskType) {
              case 'upload':
                return <UploadItem task={task} key={task.id} />;
              case 'download':
                return <DownloadItem task={task} key={task.id} />;
              case 'export':
                return null;
              case 'import':
                return null;
              default:
            }
            return null;
          },
        }}
      />
      <div
        className="px-4 animate-hover animate-click py-2 text-t2 rounded-none border-t border-grey6 text-grey3"
        onClick={clearUploadInfo}
      >
        清空已完成 / 失败
      </div>
    </div>
  );
};
